var TemplateLibraryHeaderLogoView;

TemplateLibraryHeaderLogoView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-template-library-header-logo',

	id: 'kitbuilder-template-library-header-logo',

	events: {
		'click': 'onClick'
	},

	onClick: function() {
		kitbuilder.templates.setTemplatesSource( 'local' );
		kitbuilder.templates.showTemplates();
	}
} );

module.exports = TemplateLibraryHeaderLogoView;
